module.exports = __webpack_public_path__ + "img/img1.79157b19.svg";